<template>
    <ul class="nav_breadcrumbs">
        <li><router-link to="/modules/home">{{lang.LBL_HOME}}</router-link></li>
        <li><router-link to="/modules/reminders/edit">{{lang.LBL_ADD_REMINDER}}</router-link></li>
        <li><router-link to="/modules/reminders">{{lang.LBL_VIEW_REMINDER}}</router-link></li>
    </ul>
</template>
<script>
import lang from "@/views/modules/Reminders/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
           
        }
     },
     mounted() {
        this.lang = lang;
       
    },
    methods:{
       
    }
}
</script>
